/*
 * Remove empty Tabset
 * Version 1.0
 * Octave
 **/

(function () {
  'use strict';

  angular
    .module('directive.clear-uib-tab', [])

    .directive('uibTabset', function () {
      return {
        priority: 0,
        // eslint-disable-next-line
        link: function (scope, element, attrs) {
          if (!element.find('uib-tab').length) {
            var $parent = element.parent();
            element.remove();
            if (angular.isDefined(attrs.removeParentIfEmpty)) {
              $parent.remove();
            }
          }
        }
      };
    });

})();
